// @flow
import React from "react"
import { Portal } from "react-overlays"
import ReactTransition from "react-addons-css-transition-group"
import classnames from "classnames"
import type { Node } from "react"

import SidebarOverlay from "./SidebarOverlay"
import CloseByKey from "../CloseByKey/CloseByKey"

type Props = {
  onHide: () => void,
  show: boolean,
  renderAlways?: boolean,
  children: Node,
  hideBelowModals?: boolean,
  disableAnimationOnSmallScreen?: boolean,
  disableAnimationOnTinyScreen?: boolean,
  wide?: boolean,
}

const Sidebar = ({
  onHide,
  show,
  renderAlways,
  children,
  wide,
  hideBelowModals = false,
  disableAnimationOnSmallScreen = false,
  disableAnimationOnTinyScreen = false,
}: Props) => (
  <Portal>
    <ReactTransition
      component="div"
      transitionName="Sidebar"
      transitionEnterTimeout={300}
      transitionLeaveTimeout={300}
    >
      {(show || renderAlways) && (
        <CloseByKey onClose={onHide}>
          <div
            key="Sidebar-wrap"
            className={classnames("Sidebar-wrap", {
              disableAnimationOnSmallScreen,
              disableAnimationOnTinyScreen,
              hide: !show,
            })}
          >
            <SidebarOverlay onClick={onHide} hideBelowModals={hideBelowModals} />
            <div
              className={classnames("Sidebar", {
                wide,
                hideBelowModals,
              })}
              data-test="Sidebar"
            >
              {children}
            </div>
          </div>
        </CloseByKey>
      )}
    </ReactTransition>
  </Portal>
)

export default Sidebar
